var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sucesso"},[_c('div',{staticClass:"text-box"},[_c('h2',[_vm._v(_vm._s(this.$root.mensagem)+" com sucesso!!")]),_c('p',[_vm._v("Clique\n            "),_c('router-link',{staticClass:"link",attrs:{"to":"/"}},[_vm._v("aqui")]),_vm._v("\n            para ir para o início\n        ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }